module.exports = __webpack_public_path__ + "img/md-color-wand.cc9341d0.svg";